"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.988 18.42h-6.21c-.833 0-1.484-.452-1.765-1.224-.274-.75-.05-1.554.572-2.079.215-.181.439-.36.622-.57.376-.433.54-.954.541-1.525.003-1.336-.027-2.674.013-4.008.047-1.533.624-2.87 1.662-4 .911-.992 2.03-1.638 3.355-1.889 1.983-.375 3.763.092 5.298 1.405 1.14.976 1.828 2.226 2.085 3.705.059.341.084.693.087 1.04q.015 1.823.002 3.647c-.005.855.313 1.547 1 2.062.392.295.687.655.802 1.146a1.865 1.865 0 0 1-1.543 2.279c-.094.013-.19.011-.286.011zM12 19.604c.61 0 1.22-.003 1.83.001.504.004.835.455.681.918a.69.69 0 0 1-.663.474q-1.848.006-3.696 0a.69.69 0 0 1-.698-.694.683.683 0 0 1 .693-.697c.618-.006 1.236-.001 1.854-.002"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertFillIcon24.js.map